// extracted by mini-css-extract-plugin
export default {"body":"job-details-edit_body__yFE-Z","detailsCardWrapper":"job-details-edit_detailsCardWrapper__DF2nP","detailsCard":"job-details-edit_detailsCard__f7SqC"};